interface ArrayWindowOptions {
  incrementCount?: number;
  startIndex?: number;
}

export function useArrayWindow<T>(array: MaybeRefOrGetter<T[] | readonly T[]>, options: ArrayWindowOptions = {}) {
  const {
    incrementCount: inputIncrementCount = 10,
    startIndex: inputStartIndex = 0
  } = options;

  const incrementCount = ref(inputIncrementCount);
  const windowSize = ref(inputIncrementCount);
  const startIndex = ref(inputStartIndex);

  const window = computed(() => {
    return toValue(array).slice(startIndex.value, startIndex.value + windowSize.value);
  });

  const isAllLoaded = computed(() => {
    return toValue(array).length <= startIndex.value + windowSize.value;
  });

  function resetWindow() {
    startIndex.value = inputStartIndex;
    windowSize.value = inputIncrementCount;
  }

  return { window, windowSize, startIndex, incrementCount, isAllLoaded, resetWindow };
}
